/** 注意： meta  key 一旦确定不可修改 且 同级唯一。 是作为识别这个对象的唯一标识！！！   */

// 用户管理
export const userManageRoutes = [
  {
    path: "/userList",
    name: "userList",
    meta: {
      title: "用户列表",
      key: 'user-list',
      pageApisPrm: import("@/views/userManage/userList.vue").then(({ pageApiList }: any) => pageApiList)
    },
    component: () =>
      import(/* webpackChunkName: "userManage" */ "@/views/userManage/userList.vue"),
  },
  {
    path: "/coachInfoManage",
    name: "coachInfoManage",
    meta: {
      title: "助教管理",
      key: 'coach-info-manage',
      pageApisPrm: import("@/views/userManage/coachInfoManage.vue").then(({ pageApiList }: any) => pageApiList)
    },
    component: () =>
      import(/* webpackChunkName: "userManage" */ "@/views/userManage/coachInfoManage.vue"),
  },
  {
    path: "/allianceBusinessList",
    name: "allianceBusinessList",
    meta: {
      title: "助教加盟商管理",
      key: 'coach-alliance-business-list',
      asideHidden: true, // 侧边栏不显示
      pageApisPrm: import("@/views/userManage/allianceBusinessList.vue").then(({ pageApiList }: any) => pageApiList)
    },
    component: () =>
      import(/* webpackChunkName: "userManage" */ "@/views/userManage/allianceBusinessList.vue"),
  },
  // appointOrderList
  {
    path: "/appointOrderList",
    name: "appointOrderList",
    meta: {
      title: "预约台球订单",
      key: 'appoint-order-list',
      pageApisPrm: import("@/views/userManage/appointOrderList.vue").then(({ pageApiList }: any) => pageApiList)
    },
    component: () =>
      import(
        /* webpackChunkName: "userManage" */ "@/views/userManage/appointOrderList.vue"
      ),
  },
  {
    path: "/orderList",
    name: "orderList",
    meta: {
      title: "台球订单",
      key: 'order-list',
      pageApisPrm: import("@/views/userManage/orderList.vue").then(({ pageApiList }: any) => pageApiList)
    },
    component: () =>
      import(
        /* webpackChunkName: "userManage" */ "@/views/userManage/orderList.vue"
      ),
  },
  {
    path: "/chessOrderList",
    name: "chessOrderList",
    meta: {
      title: "棋牌订单列表",
      key: 'chess-order-list',
      pageApisPrm: import("@/views/userManage/chessOrderList.vue").then(({ pageApiList }: any) => pageApiList)
    },
    component: () =>
      import(
        /* webpackChunkName: "userManage" */ "@/views/userManage/chessOrderList.vue"
      ),
  },
  {
    path: "/coachOrderList",
    name: "coachOrderList",
    meta: {
      title: "助教订单列表",
      key: 'coach-order-list',
      pageApisPrm: import("@/views/userManage/coachOrderList.vue").then(({ pageApiList }: any) => pageApiList)
    },
    component: () =>
      import(
        /* webpackChunkName: "userManage" */ "@/views/userManage/coachOrderList.vue"
      ),
  },
  {
    path: '/goodsOrderList',
    name: 'goodsOrderList',
    meta: {
      title: "商品订单列表",
      key: 'goods-order-list',
      pageApisPrm: import("@/views/userManage/goodsOrderList.vue").then(({ pageApiList }: any) => pageApiList)
    },
    component: () =>
      import(
        /* webpackChunkName: "userManage" */ "@/views/userManage/goodsOrderList.vue"
      ),
  },
  {
    path: '/ktvOrderList',
    name: 'ktvOrderList',
    meta: {
      title: "大明星订单列表",
      key: 'ktv-order-list',
      pageApisPrm: import("@/views/userManage/ktvOrderList.vue").then(({ pageApiList }: any) => pageApiList)
    },
    component: () =>
      import(
      /* webpackChunkName: "userManage" */ "@/views/userManage/ktvOrderList.vue"
      ),
  },

  {
    path: '/idolGoodsOrderList',
    name: 'idolGoodsOrderList',
    meta: {
      title: "大明星商品订单列表",
      key: 'idol-goods-order-list',
      pageApisPrm: import("@/views/userManage/idolGoodsOrderList.vue").then(({ pageApiList }: any) => pageApiList)
    },
    component: () =>
      import(
        /* webpackChunkName: "userManage" */ "@/views/userManage/idolGoodsOrderList.vue"
      ),
  },
  // idolDrinkPackageOrderList
  {
    path: '/idolDrinkPackageOrderList',
    name: 'idolDrinkPackageOrderList',
    meta: {
      title: "大明星酒水套餐",
      key: 'idol-drink-package-order-list',
      pageApisPrm: import("@/views/userManage/idolDrinkPackageOrderList.vue").then(({ pageApiList }: any) => pageApiList)
    },
    component: () =>
      import(
        /* webpackChunkName: "userManage" */ "@/views/userManage/idolDrinkPackageOrderList.vue"
      ),
  },
  { // idolOnSaleGoodsOrderList
    path: '/idolOnSaleGoodsOrderList',
    name: 'idolOnSaleGoodsOrderList',
    meta: {
      title: "大明星商品点单列表",
      key: 'idol-onsale-goods-order-list',
      pageApisPrm: import("@/views/userManage/idolOnSaleGoodsOrderList.vue").then(({ pageApiList }: any) => pageApiList)
    },
    component: () =>
      import(
        /* webpackChunkName: "userManage" */ "@/views/userManage/idolOnSaleGoodsOrderList.vue"
      ),

  },

  // idolSaleMachineAbnormalGoodsOrderList
  {
    path: '/idolSaleMachineAbnormalGoodsOrderList',
    name: 'idolSaleMachineAbnormalGoodsOrderList',
    meta: {
      title: "大明星商品异常订单列表",
      key: 'idol-sale-machine-abnormal-goods-order-list',
      pageApisPrm: import("@/views/userManage/idolSaleMachineAbnormalGoodsOrderList.vue").then(({ pageApiList }: any) => pageApiList)
    },
    component: () =>
      import(
        /* webpackChunkName: "userManage" */ "@/views/userManage/idolSaleMachineAbnormalGoodsOrderList.vue"
      ),
  },

  // idolAbnormalGoodsOrderDetail
  {
    path: '/idolAbnormalGoodsOrderDetail',
    name: 'idolAbnormalGoodsOrderDetail',
    meta: {
      title: "大明星商品异常订单详情",
      key: 'idol-abnormal-goods-order-detail',
      asideHidden: true, // 侧边栏不显示
      pageApisPrm: import("@/views/userManage/idolAbnormalGoodsOrderDetail.vue").then(({ pageApiList }: any) => pageApiList)
    },
    component: () =>
      import(
        /* webpackChunkName: "userManage" */ "@/views/userManage/idolAbnormalGoodsOrderDetail.vue"
      ),
  },

  // idolSupplementCreateGoodsOrder
  {
    path: '/idolSupplementCreateGoodsOrder',
    name: 'idolSupplementCreateGoodsOrder',
    meta: {
      title: "大明星商品异常订单补款",
      key: 'idol-supplement-create-goods-order',
      asideHidden: true, // 侧边栏不显示
      pageApisPrm: import("@/views/userManage/idolSupplementCreateGoodsOrder.vue").then(({ pageApiList }: any) => pageApiList)
    },
    component: () =>
      import(
        /* webpackChunkName: "userManage" */ "@/views/userManage/idolSupplementCreateGoodsOrder.vue"
      ),
  },

  // ktvOrderReserveUpdateRecord
  {
    path: '/ktvOrderReserveUpdateRecord',
    name: 'ktvOrderReserveUpdateRecord',
    meta: {
      title: "大明星订单预约修改记录",
      key: 'ktv-order-reserve-update-record',
      asideHidden: true, // 侧边栏不显示
      pageApisPrm: import("@/views/userManage/ktvOrderReserveUpdateRecord.vue").then(({ pageApiList }: any) => pageApiList)
    },
    component: () =>
      import(
        /* webpackChunkName: "userManage" */ "@/views/userManage/ktvOrderReserveUpdateRecord.vue"
      ),
  },
]